(function () {
    "use strict";
    $(document).ready(function () {
        $('.selectpicker').selectpicker();
        
        //GUI Spinner Actions
        ////////////////////////////////////////////////////////////////////////////////////////////////////////        
        $(document).on("click", ".SpinLink", function () {
            SpinnerSpin();
        });

        $(document).on("submit", ".FormLoading", function () {
            SpinnerSpin();
        });

        $(document).on("submit", ".Formloading", function () {
            SpinnerSpin();
        });

        //initialize validation object for all forms 
        var validation = new mclValidation("Frmvalidation");        

        //Confirm messages
        var confirmswal = false;
        $(document).on("click", ".LinkConfirm", function (e) { 
            var $el = $(this);         

            if (!confirmswal) {               
                e.preventDefault();
                swal({
                    title: "",
                    text: $el.data("cmessage"),
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#43ac6a",
                    confirmButtonText: "Yes",
                    closeOnConfirm: false
                },
                function (isConfirm) {
                    if (isConfirm) {                        
                        confirmswal = true;                        
                        $el.click();                        
                    } 
                });
            } else {
                SpinnerSpin();
                window.location.href = $el.attr('href');
            }
        });        

        //Scroll Top
        $(window).bind("scroll", function () {
            if (window.scrollY >= 200) {
                $(".ScrollTop").fadeIn(200);
            } else {
                $(".ScrollTop").fadeOut(200);
            };
        })

        $(".ScrollTop").click(function () {
            $('html, body').animate({ scrollTop: 0 }, function () { });
        });
        ////////////////////////////////////////////////////////////////////////////////////////////////////////                    

        //One Offs
        ////////////////////////////////////////////////////////////////////////////////////////////////////////        
        base_url = $("#hurl").val();

        $(".DatePicker").datepicker({
            changeMonth: true,
            changeYear: true
        });
        
        $(document).on("submit", "form", function (e) {
            var $el = $(this);
            if ($el.hasClass("NoRequestToken")) {
                console.log("nrt");
                e.preventDefault();
                $el.find("input[name=__RequestVerificationToken]").remove();
                $el.removeClass("NoRequestToken");
                $el.submit();
            }
        });
        ////////////////////////////////////////////////////////////////////////////////////////////////////////

        //Clear Formatting on Forms with ClearFormatting present
        ////////////////////////////////////////////////////////////////////////////////////////////////////////
        $(document).on("submit", "form", function (e) {
            var $el = $(this);
            if ($el.find(".ClearFormatting").length > 0) {
                e.preventDefault();
                console.log("clearformating");
                $el.find(".ClearFormatting").each(function (i, obj) {
                    $(obj).val($(obj).val().replace(/[^0-9.-]/gi, ''));
                    $(obj).removeClass("ClearFormatting");
                });
                $el.submit();
            }
        });
        ////////////////////////////////////////////////////////////////////////////////////////////////////////

        //Window Load functions
        ////////////////////////////////////////////////////////////////////////////////////////////////////////
        $(window).load(function () {
            Center();
            $(window).resize(function () {
                Center();
            });

            $(".sidebar").removeClass("NoDisplay");
        });

        $(".ExportButton").removeClass("NoDisplay");

        $(".DataTable").removeClass("NoDisplay");
        $(".DataTable").dataTable({
            "sScrollY": "500px",
            "scrollCollapse": true,
            "paging": true,
            "scrollX": true,
            "order": [],
            "lengthMenu": [[-1, 10, 25, 50, 75, 100], ["All", 10, 25, 50, 75, 100]],
            "ordering": !$(".DataTable").hasClass("NoSort")
        });

        $(".DataTableSmall").removeClass("NoDisplay");
        $(".DataTableSmall").dataTable({
            "sScrollY": "250px",
            "scrollCollapse": true,
            "paging": true,
            "scrollX": true,
            "order": [],
            "lengthMenu": [[-1, 10, 25, 50, 75, 100], ["All", 10, 25, 50, 75, 100]],
            "ordering": !$(".DataTable").hasClass("NoSort")
        });

        function Center() {
            var H = ($(window).height() / 2) - ($("#SpinnerContainer").height() / 2);
            var W = ($(window).width() / 2) - ($("#SpinnerContainer").width() / 2);
            $("#SpinnerContainer").css("top", H + "px");
            $("#SpinnerContainer").css("left", W + "px");
        }
        ////////////////////////////////////////////////////////////////////////////////////////////////////////        

        //Warning SWAL
        ////////////////////////////////////////////////////////////////////////////////////////////////////////        
        var wswal = false;
        $(document).on("click", ".WarningSwal", function (e) {
            var $el = $(this);

            if (!wswal) {
                e.preventDefault();

                swal({
                    title: "",
                    text: $el.data("wmessage"),
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#43ac6a",
                    confirmButtonText: "Yes",
                    closeOnConfirm: false
                },
                function (isConfirm) {
                    if (isConfirm) {
                        wswal = true;
                        $el.click();
                    } else {

                    }
                });
            }
        });
        ////////////////////////////////////////////////////////////////////////////////////////////////////////      
    });
})();

base_url = "";

function SpinnerSpin() {
    $("#SpinnerContainer").css("z-index", "999999");
    $("#SpinnerContainer i").removeClass("NoDisplay");
}

function SpinnerStop() {
    $("#SpinnerContainer").css("z-index", "-1");
    $("#SpinnerContainer i").addClass("NoDisplay");
}

Back = function () {
    window.history.back();
};

Close = function () {
    window.close();
}

ValidateForm = new mclValidation("ValidateForm");

StartDLTimer = function () { };
RefreshDLTimer = function () { };

ReinitDataTables = function () {
    $(".DataTable").DataTable().destroy();
    $(".DataTable").removeClass("NoDisplay");
    $(".DataTable").dataTable({
        "sScrollY": "500px",
        "scrollCollapse": true,
        "paging": true,
        "scrollX": true,
        "order": [],
        "lengthMenu": [[-1, 10, 25, 50, 75, 100], ["All", 10, 25, 50, 75, 100]],
        "ordering": !$(".DataTable").hasClass("NoSort")
    });

    $(".DataTableSmall").DataTable().destroy();
    $(".DataTableSmall").removeClass("NoDisplay");
    $(".DataTableSmall").dataTable({
        "sScrollY": "250px",
        "scrollCollapse": true,
        "paging": true,
        "scrollX": true,
        "order": [],
        "lengthMenu": [[-1, 10, 25, 50, 75, 100], ["All", 10, 25, 50, 75, 100]],
        "ordering": !$(".DataTable").hasClass("NoSort")
    });
};